(function () {
  'use strict';

  if (window.__amazonAdEventsInitialized) return;
  window.__amazonAdEventsInitialized = true;

  window.__amazonPageViewFired = false;
  window.__amazonCheckoutFired = false;
  window.__amazonAatBootstrapped = false;
  window.__amazonAatSdkLoaded = false;

  function getConfig() {
    return window.__amazonAatConfig || {};
  }

  function ensureAmznQueue() {
    if (typeof window.amzn === 'function') return;
    window.amzn = function () {
      window.amzn.q.push([arguments, new Date().getTime()]);
    };
    window.amzn.q = [];
    window.amzn.version = '0.0';
  }

  function safeTrack(eventName, payload) {
    try {
      ensureAmznQueue();
      if (payload !== undefined) {
        window.amzn('trackEvent', eventName, payload);
      } else {
        window.amzn('trackEvent', eventName);
      }
    } catch (e) {
      console.warn('Amazon AAT track error:', e);
    }
  }

  window.trackAmazonPageView = function () {
    if (window.__amazonPageViewFired) return;
    window.__amazonPageViewFired = true;
    safeTrack('PageView');
  };

  window.trackAmazonAddToCart = function () {
    safeTrack('AddToShoppingCart');
  };

  window.trackAmazonCheckout = function () {
    if (window.__amazonCheckoutFired) return;
    window.__amazonCheckoutFired = true;
    safeTrack('Checkout');
  };

  function injectAmazonSdk(config) {
    if (document.getElementById('amzn-pixel')) return;

    var script = document.createElement('script');
    script.src = config.sdkSrc || 'https://c.amazon-adsystem.com/aat/amzn.js';
    script.id = 'amzn-pixel';
    script.async = true;
    script.onload = function () {
      window.__amazonAatSdkLoaded = true;
    };
    script.onerror = function () {
      console.warn('Amazon AAT SDK failed to load');
    };
    var first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else if (document.head) {
      document.head.appendChild(script);
    }
  }

  function activateAmazonAat() {
    if (window.__amazonAatBootstrapped) {
      window.trackAmazonPageView();
      return;
    }
    window.__amazonAatBootstrapped = true;

    var config = getConfig();
    ensureAmznQueue();
    try {
      // Buffer bootstrap + events in amzn.q until amzn.js loads and flushes.
      window.amzn('setRegion', config.region || 'NA');
      window.amzn('addTag', config.tagId);
    } catch (e) {
      console.warn('Amazon AAT bootstrap error:', e);
      return;
    }

    window.trackAmazonPageView();
    injectAmazonSdk(config);
  }

  function isContinueShoppingElement(el) {
    if (!el || !el.classList) return false;
    return (
      el.classList.contains('cart-drawer__continue-button') ||
      el.classList.contains('continue-shopping-button') ||
      el.classList.contains('cart__continue-button')
    );
  }

  function isCheckoutHref(href) {
    if (!href || typeof href !== 'string') return false;
    if (href.indexOf('/collections') !== -1 || href.indexOf('/products') !== -1) {
      return false;
    }
    if (href.indexOf('/cart') === 0 && href.indexOf('/checkout') === -1) {
      return false;
    }
    return href.indexOf('/checkout') !== -1;
  }

  function isCheckoutElement(el) {
    if (!el || typeof el.getAttribute !== 'function') return false;
    if (isContinueShoppingElement(el)) return false;

    var name = el.getAttribute('name');
    if (name === 'checkout') return true;

    var href = el.getAttribute('href');
    if (isCheckoutHref(href)) return true;

    var action = el.getAttribute('action');
    if (action && action.indexOf('/checkout') !== -1) return true;

    if (el.classList) {
      if (
        el.classList.contains('cart-sticky-checkout__button') ||
        el.classList.contains('cart__checkout-button') ||
        el.classList.contains('so-btn-checkout') ||
        el.classList.contains('shopify-payment-button__button') ||
        (el.classList.contains('cart-drawer__checkout-button') &&
          !el.classList.contains('cart-drawer__continue-button'))
      ) {
        return true;
      }
    }

    return false;
  }

  function findCheckoutAncestor(start) {
    var curr = start;
    while (curr && curr !== document && curr !== window) {
      if (isCheckoutElement(curr)) return curr;
      curr = curr.parentElement;
    }
    return null;
  }

  function isCheckoutForm(form) {
    if (!form || typeof form.getAttribute !== 'function') return false;
    if (isCheckoutElement(form)) return true;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart') === -1 && action.indexOf('/checkout') === -1) {
      return false;
    }

    if (typeof form.querySelector !== 'function') return false;
    var checkoutControl = form.querySelector(
      '[name="checkout"], .cart__checkout-button, .cart-drawer__checkout-button, .cart-sticky-checkout__button, .so-btn-checkout, .shopify-payment-button__button'
    );
    return Boolean(checkoutControl && !isContinueShoppingElement(checkoutControl));
  }

  function isSubmitControl(el) {
    if (!el || typeof el.getAttribute !== 'function') return false;
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'button') {
      var type = (el.getAttribute('type') || 'submit').toLowerCase();
      return type === 'submit' || type === 'image';
    }
    if (tag === 'input') {
      var inputType = (el.getAttribute('type') || '').toLowerCase();
      return inputType === 'submit' || inputType === 'image';
    }
    return false;
  }

  /**
   * Checkout tracking runs on window bubble so document listeners can cancel
   * first. Track synchronously so navigation cannot drop the callback.
   * Same-origin .shopify-payment-button__button is covered; Shop Pay /
   * Apple Pay iframe clicks are not observable from theme JS.
   */
  function initCheckoutListeners() {
    window.addEventListener(
      'click',
      function (e) {
        if (e.defaultPrevented) return;

        var checkoutEl = findCheckoutAncestor(e.target);
        if (!checkoutEl) return;

        if (isSubmitControl(checkoutEl)) {
          var form =
            checkoutEl.form ||
            (typeof checkoutEl.closest === 'function' ? checkoutEl.closest('form') : null);
          if (form) return;
        }

        window.trackAmazonCheckout();
      },
      false
    );

    window.addEventListener(
      'submit',
      function (e) {
        if (e.defaultPrevented) return;

        var form = e.target;
        var submitter = e.submitter || null;
        var matched =
          (submitter && Boolean(findCheckoutAncestor(submitter))) ||
          isCheckoutForm(form) ||
          Boolean(findCheckoutAncestor(form));

        if (matched) {
          window.trackAmazonCheckout();
        }
      },
      false
    );
  }

  if (typeof document !== 'undefined') {
    activateAmazonAat();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCheckoutListeners);
    } else {
      initCheckoutListeners();
    }
  }
})();
